import { NgModule } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { ConfirmDialogComponent } from '@recruitee/user-interface';

import { BlockPasswordChangeDialogComponent } from '../dialogs/block-password-change-dialog/block-password-change-dialog.component';

@NgModule({
  imports: [
    ConfirmDialogComponent,
    TranslatePipe,
    TranslatePipe,
    TranslatePipe,
    TranslatePipe,
    BlockPasswordChangeDialogComponent,
  ],
  exports: [BlockPasswordChangeDialogComponent],
})
export class RtBlockPasswordChangeDialogSharedModule {}

export { BlockPasswordChangeDialogComponent };
